import { handleActions } from 'redux-actions'
import { fetchYearsStart, fetchYearsSuccess, fetchYearsError } from 'actions/activeYears'

const defaultState = {
  values: null,
  isFetching: false,
  error: null
}

const reducer = handleActions(
  {
    [fetchYearsStart]: state => ({
      ...state,
      isFetching: true,
      error: false,
      values: false
    }),
    [fetchYearsSuccess]: (
      state,
      {
        payload: {
          data: { values }
        }
      }
    ) => ({
      ...state,
      values: values,
      isFetching: false,
      error: null
    }),
    [fetchYearsError]: (state, { error }) => ({
      ...state,
      isFetching: false,
      values: false,
      error: error
    })
  },
  defaultState
)

export default reducer
